module.exports = "//static.hsappstatic.net/salesImages/static-1.403/meetings/demo_screen.png"